import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpune() {



const cardData = {
  keyword: "Urbania On Rent in Pune",
  heading: "Lotus Cab: Urbania On Rent in Pune",

  headingDescription:
    "Lotus Cab offers premium Force Urbania on rent in Pune for group travel, corporate tours, weddings, airport transfers, and long-distance journeys. Our fleet includes 10, 13, and 17-seater AC Urbania vans designed with spacious seating and superior suspension for maximum comfort. Each vehicle is well-maintained, sanitized, and driven by experienced professional chauffeurs. We provide transparent per-km pricing with flexible local and outstation packages. Whether you need a luxury executive van or a comfortable group travel vehicle, Lotus Cab ensures safe, smooth, and reliable Urbania rental service across Pune.",

  top: "Top Places to Visit in Pune with Urbania Rental",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Iconic historical fort in central Pune. Popular for group sightseeing tours. Ideal for family and corporate visits. Urbania van ensures comfortable group transport."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Historic hill fort near Pune. Popular weekend trekking destination. Perfect for group outings. Spacious Urbania makes hill travel convenient."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Important monument of India’s freedom history. Ideal for educational tours. Urbania provides smooth city travel."
    },
    {
      title: "Dagdusheth Ganpati Temple",
      description:
        "Famous spiritual temple in Pune. Frequently visited by families. Urbania ensures comfortable darshan travel."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Scenic picnic spot near Pune. Popular among groups. AC Urbania offers relaxed weekend travel."
    },
    {
      title: "Lavasa",
      description:
        "Beautiful hill city destination. Ideal for corporate outings. Urbania ensures smooth highway travel."
    },
    {
      title: "Lonavala",
      description:
        "Weekend getaway near Pune. Group travel preferred. Comfortable Urbania van makes journey enjoyable."
    },
    {
      title: "Mahabaleshwar",
      description:
        "Popular hill station for families. Spacious luggage support needed. Urbania rental ensures comfortable long-distance travel."
    }
  ],

  services: [
    {
      name: "Force Urbania On Rent in Pune",
      description:
        "Premium Force Urbania rental in Pune with AC seating and spacious interiors. Ideal for group tours and corporate travel. Professional driver included."
    },
    {
      name: "10 Seater Urbania Pune",
      description:
        "Comfortable 10-seater Urbania for small group travel. Suitable for airport transfers and local trips. AC and luxury seating available."
    },
    {
      name: "13 Seater Urbania Pune",
      description:
        "Spacious 13-seater van ideal for family and corporate tours. Well-maintained vehicle with professional chauffeur."
    },
    {
      name: "17 Seater Urbania Pune",
      description:
        "Large 17-seater Urbania suitable for weddings and group events. Extra luggage space provided. Smooth long-distance travel."
    },
    {
      name: "Luxury Urbania Van Pune",
      description:
        "Premium executive van rental with comfortable interiors. Ideal for VIP and corporate events. Reliable service assured."
    },
    {
      name: "Urbania for Outstation Pune",
      description:
        "Reliable Urbania rental for long-distance travel from Pune. Safe highway driving and flexible packages available."
    },
    {
      name: "Urbania Airport Transfer Pune",
      description:
        "Convenient airport transfer service with spacious seating and luggage support. Timely pickup guaranteed."
    },
    {
      name: "Online Urbania Booking Pune",
      description:
        "Easy online booking with instant confirmation. 24/7 customer support available."
    }
  ],

  tableData: [
    ["Urbania On Rent in Pune", "Force Urbania On Rent in Pune"],
    ["10 Seater Urbania Pune", "13 Seater Urbania Pune"],
    ["17 Seater Urbania Pune", "Luxury Urbania Van Pune"],
    ["AC Urbania Hire Pune", "Urbania for Outstation Pune"],
    ["Urbania for Corporate Travel Pune", "Urbania for Wedding Pune"],
    ["Urbania Airport Transfer Pune", "Urbania Per Km Rate Pune"],
    ["Affordable Urbania Rental Pune", "Driver Included Urbania Pune"],
    ["Urbania for Group Tour Pune", "Premium Van Rental Pune"],
    ["Urbania for Long Distance Pune", "Online Urbania Booking Pune"],
    ["Best Urbania Service Pune", "Executive Van Hire Pune"]
  ],

  whychoose: [
    { WhyChooseheading: "Spacious Seating Capacity", WhyChoosedescription: "10, 13, and 17 seater options available for group comfort." },
    { WhyChooseheading: "Luxury AC Interiors", WhyChoosedescription: "Comfortable pushback seating and smooth suspension travel." },
    { WhyChooseheading: "Professional Drivers", WhyChoosedescription: "Experienced chauffeurs for city and highway routes." },
    { WhyChooseheading: "Transparent Per Km Pricing", WhyChoosedescription: "Clear fare structure with no hidden charges." },
    { WhyChooseheading: "Corporate & Wedding Ready", WhyChoosedescription: "Ideal for executive events and wedding transport." },
    { WhyChooseheading: "24/7 Booking Support", WhyChoosedescription: "Round-the-clock booking assistance available." },
    { WhyChooseheading: "Airport Transfer Convenience", WhyChoosedescription: "Timely airport pickup and drop service." },
    { WhyChooseheading: "Safe Long-Distance Travel", WhyChoosedescription: "Reliable and secure highway journey ensured." }
  ]
};

const faqData = [
  { question: "Do you provide 10 seater Urbania?", answer: "Yes, 10 seater AC Urbania available." },
  { question: "Is driver included?", answer: "Yes, professional driver included." },
  { question: "Are vehicles AC?", answer: "Yes, all Urbania vans are air-conditioned." },
  { question: "Is outstation travel available?", answer: "Yes, outstation Urbania rental available." },
  { question: "Is online booking possible?", answer: "Yes, instant booking available." },
  { question: "Do you provide luxury Urbania?", answer: "Yes, executive and premium Urbania vans available." },
  { question: "Is per km rate available?", answer: "Yes, transparent per km pricing provided." },
  { question: "Is airport transfer available?", answer: "Yes, airport pickup and drop service provided." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock booking support." },
  { question: "Can I book for wedding events?", answer: "Yes, wedding and event booking available." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Deshmukh",
    feedback:
      "Booked 13-seater Urbania for family tour. Very comfortable seating and professional driver. Excellent experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Client",
    feedback:
      "Used Urbania for corporate travel. Spacious van and smooth highway drive. Highly recommended.",
    rating: 5
  },
  {
    id: 3,
    name: "Wedding Event Client",
    feedback:
      "Luxury Urbania van booked for wedding guests. Clean vehicle and punctual service. Great support team.",
    rating: 5
  }
];







































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pune",
  "image": "https://lotuscab.com/assets/images/urbania-on-rent-pune.jpg", 
  "description": "Lotus Cab provides Force Urbania vans on rent in Pune with 10, 13, and 17 seater options. Ideal for corporate travel, weddings, airport transfers, outstation trips, long-distance travel, and group tours. Luxury and AC options available with driver included, premium service, and online booking for convenient, safe, and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/urbania-on-rent-pune"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Urbania On Rent in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Rent Force Urbania vans in Pune with Lotus Cab. 10, 13 & 17 seater AC & luxury vans for corporate travel, weddings, airport transfer, group tours & outstation trips. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Force Urbania On Rent in Pune, 10 Seater Urbania Pune, 13 Seater Urbania Pune, 17 Seater Urbania Pune, Luxury Urbania Van Pune, AC Urbania Hire Pune, Urbania for Outstation Pune, Urbania for Corporate Travel Pune, Urbania for Wedding Pune, Urbania Airport Transfer Pune, Urbania Per Km Rate Pune, Affordable Urbania Rental Pune, Driver Included Urbania Pune, Urbania for Group Tour Pune, Premium Van Rental Pune, Urbania for Long Distance Pune, Online Urbania Booking Pune, Best Urbania Service Pune, Executive Van Hire Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpune;